// Domain · DprChip helpers
//
// Tone + label resolution for the `request_dpr` tri-state flag.
// Split out of `DprChip.tsx` so that module exports components only.

import type { PillTone } from "@ds/display/Pill";
import { DPR_STATE_COLORS } from "@ds/tokens/domainTones";

type DprState = "true" | "false" | "null";

const DPR_TEXT: Record<DprState, string> = {
  true:  "Wnioskują",
  false: "Nie wnioskują",
  null:  "Nie dotyczy",
};

function stateOf(active: boolean | null | undefined): DprState {
  if (active == null) return "null";
  return active ? "true" : "false";
}

/** Resolve a DPR flag to its canonical `PillTone`. */
export function dprTone(active: boolean | null | undefined): PillTone {
  return DPR_STATE_COLORS[stateOf(active)];
}

/** Resolve a DPR flag to its canonical Polish label. */
export function dprText(active: boolean | null | undefined): string {
  return DPR_TEXT[stateOf(active)];
}
